// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/framework7/dist/css/framework7.ios.colors.css
 ** module id = 5
 ** module chunks = 0
 **/